export interface HrProUpsellContext {
  featureEnabled: boolean;
  hasHrPro: boolean;
  /** Can open the account settings area (`accountAccess.root`) — admins and managers alike. */
  canAccessSettings: boolean;
  planIsAtleastBasic: boolean;
  /** Trial accounts stay out until product decides how they get HR Pro (the free month needs a paid plan). */
  accountIsOnTrial: boolean;
}

// Shared by the primary nav (Hiring) and the Settings sidebar (HR Pro) so the two locks never disagree.
export const isHrProUpsellApplicable = ({
  featureEnabled,
  hasHrPro,
  canAccessSettings,
  planIsAtleastBasic,
  accountIsOnTrial,
}: HrProUpsellContext): boolean =>
  featureEnabled && !hasHrPro && canAccessSettings && planIsAtleastBasic && !accountIsOnTrial;
